// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"761":"99fa9d6d","866":"c58c0c1e"}[chunkId] + ".chunk.css";
};